import { ITask } from '@modules/TasksModule/types';
import { phoneState } from '../state';

function handleTaskAccept(task: ITask): void {
  const newCallsAccepting = [...phoneState.callsAccepting];
  if (task.attributes?.callId) {
    newCallsAccepting.push(task.attributes.callId);
  }
  phoneState.callsAccepting = newCallsAccepting;
}

export default handleTaskAccept;
